class TrimmedUser {
  constructor({ _id = null, firstName = '', lastName = '', avatar }) {
    const { id: imageId = null, url: imageUrl = '' } = avatar ? avatar : {};
    this.id = _id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.avatar = {
      id: imageId,
      url: imageUrl,
    };
  }
}

export default TrimmedUser;
